<div class="info-wrapper">
  <div class="feedback-alert" role="alert">
    <div>Welcome <strong><a href='https://phonetool.amazon.com/users/{{this.user["alias"]}}'>{{this.user["alias"]}}</a></strong></div>
  </div>

</div>
